import { render, staticRenderFns } from "./TermLoanItem.vue?vue&type=template&id=3f642ae2&scoped=true&"
import script from "./TermLoanItem.vue?vue&type=script&lang=js&"
export * from "./TermLoanItem.vue?vue&type=script&lang=js&"
import style0 from "./TermLoanItem.vue?vue&type=style&index=0&id=3f642ae2&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f642ae2",
  null
  
)

export default component.exports